// @flow

import React from 'react';
import styles from './imageUpload.scss';

type Props = {
  setImageFile: Function,
  id: string,
  uploadButtonString: string,
  reUploadButtonString: string
};

const DEFAULT_FILE_ID = 'files';

class ImageUpload extends React.Component<Props> {
  constructor(props) {
    super(props);
    this.state = {
      imagePreviewUrl: ''
    };
    this.handleImageChange = this.handleImageChange.bind(this);
  }

  handleImageChange(e) {
    e.preventDefault();

    const reader = new FileReader();
    const file = e.target.files[0];
    this.props.setImageFile(file);
    reader.onloadend = () => {
      this.setState({
        imagePreviewUrl: reader.result
      });
    };

    reader.readAsDataURL(file);
  }

  render() {
    const { imagePreviewUrl } = this.state;
    let $imagePreview = null;
    if (imagePreviewUrl) {
      $imagePreview = (
        <img
          className={`${styles.imgPreviewTag}`}
          src={imagePreviewUrl}
          alt="description "
        />
      );
    }

    return (
      <div className={`${styles.imgContainer} l-row j-space-bet`}>
        <div
          className={`${
            $imagePreview ? styles.imageButton : styles.imageButtonNoImage
          }`}
          onClick={() =>
            document
              .getElementById(this.props.id ? this.props.id : DEFAULT_FILE_ID)
              .click()
          }
        >
          {$imagePreview
            ? this.props.reUploadButtonString
            : this.props.uploadButtonString}
        </div>
        <input
          id={this.props.id ? this.props.id : DEFAULT_FILE_ID}
          className={`${styles.fileInput}`}
          type="file"
          accept="image/gif, image/jpeg, image/png"
          onChange={e => this.handleImageChange(e)}
        />
        <div
          className={`${
            $imagePreview ? styles.imgPreview : styles.imgPreviewNoImage
          } l-row j-center a-center flex-30`}
        >
          {$imagePreview}
        </div>
      </div>
    );
  }
}

export default ImageUpload;
